module.exports = __webpack_public_path__ + "static/img/font-awesome.3e7253f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font-awesome.jpeg
// module id = KvaM
// module chunks = 1